
import React, {useState, useEffect} from 'react';
import AdminDashboardTabs from 'views/admin/AdminDashboardTabs';
import SetoCanvasPage from 'pages/SetoCanvasPage';
import UserAPI from 'service/api/UserAPI';
import ReactTable from 'react-table'
import {A, Button} from 'views/AppElements';
import AppUtil from 'AppUtil';


const SocialMediaLink = ({link, label}) => {
    if(!link) return null;

    let url = link;
    if(!url.startsWith("http")) {
        url = "https://" + url;
    }
    
    return <A href={url} target="_blank">{label}</A>
}

const AllUsersDashboardPage = () => {
	const [users, setUsers] = useState(null);
    const [showLoading, setShowLoading] = useState(true);

    useEffect(() => {
        UserAPI.getAllUsers(0, 100, ["INFLUENCER", "MERCHANT"], "PENDING_APPROVAL", (allUsers) => {
            console.log("allUsers", allUsers);
            setUsers(allUsers);
            setShowLoading(false);
        });
    }, []);

    const approveUser = (user) => {
        const res = confirm("Are you sure you want to approve '"+user.username+"' account?");

        if(res === true) {
            setShowLoading(true);
            UserAPI.updateUserStatus(user.id, "ACTIVE", () => {
                const updatedUsers = users.map(u => {
                    if(u.id === user.id) {
                        u.userStatus = 'ACTIVE';
                    }
                    return u;
                });
                setUsers(updatedUsers);
                setShowLoading(false);
            });
        }
       
    };

    const columns = [{Header: 'Name', accessor: 'username', Cell: function(props) {
                        const u = props.original;
                        const url = AppUtil.getDesignerURL(u);
                        return <A href={url} target="_blank">{props.value}</A>
                    }}, 
                    {Header: 'Email', accessor: 'emailAddress', Cell: function(props) {
                        const u = props.original;
                        const emailVerified = u.verified;
                        return <div className="flexColumn" style={{alignItems: 'center'}}>
                            <span>{props.value}</span>
                            <span style={{color: emailVerified? 'green': 'red'}}>{emailVerified === true? 'Verified': 'Not Verified'}</span>
                        </div>
                    }},
                    {Header: 'Phone', accessor: 'phoneNumber'},
                    {Header: 'User Type', accessor: 'userType'},
                    {Header: 'Social Media', accessor: 'socialMediaAccounts', Cell: function(props) {
                        const socialMediaAccounts = props.value;
                        const fbUrl = socialMediaAccounts? socialMediaAccounts['FB']: null;
                        const instaUrl = socialMediaAccounts? socialMediaAccounts['INSTA']: null;
                        const tiktokUrl = socialMediaAccounts? socialMediaAccounts['TIKTOK']: null;
                        const youtubeUrl = socialMediaAccounts? socialMediaAccounts['YOUTUBE']: null;


                        return <div className="flexColumn" style={{justifyContent: 'space-around', fontSize: '110%', flexWrap: 'nowrap'}}>
                            <div className="flexRow" style={{justifyContent: 'space-around'}}>
                                <SocialMediaLink link={fbUrl} label="FB" />
                                <SocialMediaLink link={instaUrl} label="Instagram" />
                            </div>
                            <div className="flexRow" style={{justifyContent: 'space-around'}}>
                                <SocialMediaLink link={youtubeUrl} label="Youtube" />
                                <SocialMediaLink link={tiktokUrl} label="TikTok" />
                            </div>
                        </div>
                    }},
                    {Header: 'Action', Cell: function(props) {
                        const u = props.original;
                        return <div className="flexColumn" style={{alignItems: 'center'}}>
                                        <span>{u.userStatus}</span>

                                        {
                                            u.userStatus === 'PENDING_APPROVAL' &&
                                            <Button disabled={showLoading} style={{marginTop: '10px', background: '#f8f8ff', padding: '5px', borderRadius: '5px', cursor: 'pointer'}}
														onClick={() => {
															approveUser(u);
														}}>Approve Account</Button>
                                        }
                                        
                                </div>
                    }}
                    ];

    return (<SetoCanvasPage title="Users Dashboard | Seto Canvas" id="usersDashboardPage">
                <AdminDashboardTabs active="users">
                    <div className='mainContainer' style={{padding: '30px 0'}}>
                        <h2>Pending Users</h2>

                        <ReactTable data={users? users: []} columns={columns} minRows={5} 
                            noDataText="No Pending Users Found." loading={showLoading} 
                            className="-pending-users-highlight" defaultPageSize={15} 
						  />

                    </div>

                </AdminDashboardTabs>
            </SetoCanvasPage>
        );
}


export default AllUsersDashboardPage;


// WEBPACK FOOTER //
// ./src/pages/admin/AllUsersDashboardPage.js